function MFRHostedVideo(index, element) {
  this.$element = $(element)

  this.init()
}

MFRHostedVideo.prototype = Object.assign({}, MFRHostedVideo.prototype, {
  init: function () {
    this.$videoContainer = this.$element.find(".video-component")
    this.$video = this.$element.find("video")
    this.$playPauseButton = this.$element.find(".video-controls")
    this.$speakerButton = this.$element.find(".video-sound")

    this.$video.on("play", this.__handleVideoPlay.bind(this))
    this.$video.on("pause", this.__handleVideoPause.bind(this))
    this.$video.on("click", this.__handleVideoClick.bind(this)).on("volumechange", this.__handleVideoVolumeChange.bind(this))

    this.$playPauseButton.on("click", this.__handleControlClick.bind(this))
    this.$speakerButton.on("click", this.__handleSpeakerButtonClick.bind(this))
  },

  __handleVideoPlay: function(e) {
    this.$playPauseButton.removeClass("play pause").addClass("pause")
    this.$videoContainer.toggleClass("is-playing", !e.currentTarget.paused)
    this.$videoContainer.toggleClass("is-muted", e.currentTarget.muted)
  },

  __handleVideoPause: function(e) {
    this.$playPauseButton.removeClass("play pause").addClass("play")
    this.$videoContainer.toggleClass("is-playing", !e.currentTarget.paused)
    this.$videoContainer.toggleClass("is-muted", e.currentTarget.muted)
  },

  __handleVideoClick: function(e) {
    if ($(e.currentTarget).attr("controls")) return

    let videoElement = this.$video.get(0)

    if (videoElement.paused) {
      videoElement.play()
    } else {
      videoElement.pause()
    }
  },

  __handleControlClick: function(e) {
    let videoElement = this.$video.get(0)
    
    if (this.$playPauseButton.hasClass("pause")) {
      videoElement.pause()
    } else {
      videoElement.play()
    }
  },

  __handleVideoVolumeChange: function(e) {
    this.$videoContainer.toggleClass("is-muted", e.currentTarget.muted)
  },

  __handleSpeakerButtonClick: function(e) {
    this.$video.get(0).muted = !this.$video.get(0).muted
  }
})